import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { SITE, NAV_LINKS } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="mt-auto bg-brand-navy text-white" data-testid="site-footer">
      <div className="container-x grid gap-10 py-14 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <img
              src={SITE.iconUrl}
              alt="Maritime Thermal Solutions logo"
              className="h-12 w-12 rounded bg-white/5 object-contain p-1"
            />
            <div className="font-heading text-lg font-semibold leading-tight">
              Maritime Thermal<br />Solutions
            </div>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-white/80">
            A Nova Scotia–based homeowner outreach and appointment-setting company.
            We help homeowners explore residential heat pump options and connect with
            trusted HVAC partners in their area.
          </p>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-white">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/85">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 shrink-0 text-brand-orange" aria-hidden="true" />
              <span data-testid="footer-address">{SITE.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} className="shrink-0 text-brand-orange" aria-hidden="true" />
              <a href={SITE.phoneHref} className="hover:text-brand-orange" data-testid="footer-phone">
                {SITE.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="shrink-0 text-brand-orange" aria-hidden="true" />
              <a href={SITE.emailHref} className="hover:text-brand-orange break-all" data-testid="footer-email">
                {SITE.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Clock size={16} className="mt-0.5 shrink-0 text-brand-orange" aria-hidden="true" />
              <span>{SITE.hours}</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-white">Quick Links</h4>
          <ul className="mt-4 space-y-2 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-white/85 hover:text-brand-orange"
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-white">Service Area</h4>
          <p className="mt-4 text-sm text-white/85">
            Serving homeowners across Nova Scotia, including Halifax, Dartmouth,
            Bedford, Sackville, Truro, the Annapolis Valley, South Shore, North Shore,
            Cape Breton, and surrounding areas.
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x flex flex-col items-start justify-between gap-2 py-5 text-xs text-white/70 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Maritime Thermal Solutions Inc. All rights reserved.</p>
          <p>
            Maritime Thermal Solutions is not a government agency, utility company, or HVAC installer.
          </p>
        </div>
      </div>
    </footer>
  );
}
